import { useTranslation } from "react-i18next";
import { config } from "../helpers/config";
import { getReferral } from "../helpers/referral";
import { trackEvent } from "../helpers/tracking";
import { safeNext } from "../helpers/global";

/**
 * "Continue with Google" — starts the Google round trip on storak-auth
 * (/api/oauth/google). Existing accounts land in their store admin; new
 * e-mails get the blocking store-details step (pages/google-complete.js).
 */
export const GoogleButton = ({ source = "login" }) => {
  const { t, i18n } = useTranslation();
  const lng = String(i18n.language || "").toLowerCase().startsWith("ar") ? "ar" : "en";

  const start = () => {
    const params = new URLSearchParams({ lng });
    const { affiliateRef, affiliateRefAt } = getReferral();
    if (affiliateRef) {
      params.set("ref", affiliateRef);
      params.set("refAt", String(affiliateRefAt));
    }
    const next = safeNext();
    if (next) {
      params.set("next", next);
    }
    trackEvent("google_auth_start", undefined, { source, language: lng });
    window.location.href = `${config.storakAuthApiUrl}/api/oauth/google?${params}`;
  };

  return (
    <>
      <button type="button" className="sp-google-btn" onClick={start}>
        <svg viewBox="0 0 48 48" width="20" height="20" aria-hidden="true">
          <path fill="#FFC107" d="M43.6 20.5H42V20H24v8h11.3C33.7 32.7 29.2 36 24 36c-6.6 0-12-5.4-12-12s5.4-12 12-12c3.1 0 5.8 1.2 7.9 3.1l5.7-5.7C34 6.1 29.3 4 24 4 12.9 4 4 12.9 4 24s8.9 20 20 20 20-8.9 20-20c0-1.3-.1-2.4-.4-3.5z"/>
          <path fill="#FF3D00" d="M6.3 14.7l6.6 4.8C14.7 15.1 19 12 24 12c3.1 0 5.8 1.2 7.9 3.1l5.7-5.7C34 6.1 29.3 4 24 4 16.3 4 9.7 8.3 6.3 14.7z"/>
          <path fill="#4CAF50" d="M24 44c5.2 0 9.9-2 13.4-5.2l-6.2-5.2C29.2 35.1 26.7 36 24 36c-5.2 0-9.6-3.3-11.3-8l-6.5 5C9.5 39.6 16.2 44 24 44z"/>
          <path fill="#1976D2" d="M43.6 20.5H42V20H24v8h11.3c-.8 2.2-2.2 4.2-4.1 5.6l6.2 5.2C37 39.2 44 34 44 24c0-1.3-.1-2.4-.4-3.5z"/>
        </svg>
        <span>{t("google.continue", "Continue with Google")}</span>
      </button>
      <div className="sp-or"><span>{t("google.or", "or")}</span></div>
    </>
  );
};
